import { ListLoader } from '../list-loader/list-loader';
import { AbstractComponent } from './abstract.component';
import { first } from 'rxjs/operators';
import { LoadingState } from '../list-loader/loading-state';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Directive } from '@angular/core';

@Directive()
export abstract class AbstractNavigateBackComponent extends AbstractComponent {
  constructor(
    protected translate: TranslateService,
    protected capAlertService: CapAlertService,
    protected location: Location
  ) {
    super();
  }

  addLoaderAndNavigateBackIfEmpty(listLoader: ListLoader<any>) {
    super.addLoader(listLoader);
    this.addSub(
      listLoader.state$
        .pipe(first((state) => state === LoadingState.ALL_DATA_LOADED && listLoader.hasNoItems))
        .subscribe(() => this.noItemsFound())
    );
  }

  private noItemsFound() {
    this.capAlertService.info(this.translate.instant('KeineResultateGefunden'), undefined, true);
    this.location.back();
  }
}
